import React, { useState, useEffect } from 'react';
import { Helmet } from 'react-helmet-async';
import sadhu1 from '../images/sadhu1.png';
import { IoArrowUpCircleOutline } from "react-icons/io5";
import { MdCall } from 'react-icons/md';
import { TfiEmail } from "react-icons/tfi";
import { IoLogoWhatsapp } from "react-icons/io";
import { Player, Controls } from '@lottiefiles/react-lottie-player';

export default function Sadhvi() {
  const lottiee = require('../images/lottiee.json');
  const loading = require('../images/loading.json');

  const [sadvikData, setsadvikData] = useState([]);
  const [loader, setloader] = useState(false);

  const sadvikList = () => {
    setloader(true);
    const requestOptions = {
      method: "GET",
      redirect: "follow",
    };

    // ✅ Fixed: Removed extra space in URL
    fetch("https://api.padampura.com/MuniSadviksList", requestOptions)
      .then((response) => {
        if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
        return response.json();
      })
      .then((result) => {
        if (result.status === true && result.data?.MunisSadviksData) {
          setsadvikData(result.data.MunisSadviksData);
        } else {
          console.warn("No data found or invalid response");
        }
      })
      .catch((error) => console.error("Fetch error (MuniSadviksList):", error))
      .finally(() => setloader(false));
  };

  useEffect(() => {
    scrollToTop();
    sadvikList();
  }, []);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  return (
    <div>
      <Helmet>
        <title>Jain Monks and Nuns (Sadhu & Sadhvi) | Padampura Temple</title>
        <meta name="description" content="Explore the lives of Jain monks and nuns associated with Padampura Temple. View their Sangh details, contact information, and spiritual roles." />
        <meta name="keywords" content="Jain Muni, Jain Sadhvi, Sadhu Sadhvi, Jain Monks, Jain Nuns, Padampura Temple, Spiritual Leaders, Jainism" />
        <meta name="author" content="Padampura Temple Administration" />
        <meta name="robots" content="index, follow" />

        {/* Open Graph / Social */}
        <meta property="og:title" content="Jain Monks and Nuns - Sadhu & Sadhvi | Padampura Temple" />
        <meta property="og:description" content="Meet the Jain spiritual leaders serving under Padampura Temple." />
        <meta property="og:type" content="website" />
        {/* ✅ Fixed: Use live domain */}
        <meta property="og:url" content="https://padampuraji.in/Sadhvi" />
        <meta property="og:site_name" content="Padampura Temple" />
        <meta property="og:image" content="https://padampuraji.in/logo192.png" />
        <meta property="og:image:alt" content="Official logo of Padampura Jain Temple" />

        {/* ✅ Fixed: Correct canonical URL */}
        <link rel="canonical" href="https://padampuraji.in/Sadhvi" />

        {/* ✅ Structured Data (JSON-LD) */}
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "WebPage",
            "name": "Jain Monks and Nuns (Sadhu & Sadhvi)",
            "url": "https://padampuraji.in/Sadhvi",
            "description": "Spiritual leaders associated with Padampura Jain Temple.",
            "publisher": {
              "@type": "Organization",
              "name": "Padampura Temple",
              "logo": {
                "@type": "ImageObject",
                "url": "https://padampuraji.in/logo192.png"
              }
            }
          })}
        </script>
      </Helmet>

      <div className='container mt-5 pt-5'>
        <h1 className='text-center' style={{
          fontFamily: 'Poppins',
          fontSize: "1.8em",
          color: '#D35400', // ✅ Better contrast than 'orangered'
          fontWeight: 600
        }}>
          Jain Monks and Nuns
        </h1>
        <p className='text-center' style={{
          fontFamily: 'Poppins',
          fontSize: ".9em",
          color: '#1f5156',
          fontWeight: 400,
          letterSpacing: 2
        }}>
          (Sadhu And Sadhvi)
        </p>

        {loader ? (
          <div className="text-center my-5">
            <p style={{ fontFamily: "Poppins", fontSize: 16 }}>Loading...</p>
            <Player
              autoplay
              loop
              src={loading}
              style={{ height: '200px', width: '200px', margin: '0 auto' }}
              aria-label="Loading animation for Jain monks and nuns data"
            >
              <Controls visible={false} />
            </Player>
          </div>
        ) : sadvikData.length === 0 ? (
          <div className="text-center my-5">
            <Player
              autoplay
              loop
              src={lottiee}
              style={{ height: '180px', width: '180px', margin: '0 auto' }}
              aria-label="No data available animation"
            >
              <Controls visible={false} />
            </Player>
            <div style={{
              fontFamily: "Poppins",
              fontSize: 16,
              color: '#E74C3C',
              marginTop: '10px'
            }}>
              Data Not Available...
            </div>
          </div>
        ) : (
          sadvikData.map((item, index) => (
            <div key={index} className='row mt-5 align-items-start'>
              <div className='col-lg-2 col-md-6 col-sm-12 mb-3 mb-lg-0'>
                <div className="card rounded-1 border-0 image-box" style={{ width: '100%' }}>
                  <img
                    src={item.MS_MuniImageStream || sadhu1}
                    alt={item.MS_MuniName ? `${item.MS_MuniName}, ${item.MS_SangName}` : "Jain Monk or Nun"}
                    style={{
                      width: "100%",
                      height: "180px",
                      objectFit: "cover",
                      borderRadius: "8px"
                    }}
                    loading="lazy"
                  />
                </div>
              </div>

              <div className='col-lg-10 col-md-6 col-sm-12'>
                <h2 style={{
                  fontSize: "1.2em",
                  fontWeight: 600,
                  color: '#D35400',
                  fontFamily: "Poppins",
                  margin: 0
                }}>
                  {item.MS_MuniName}, ({item.MS_SangName})
                </h2>

                <p style={{
                  fontFamily: 'Poppins',
                  fontSize: "13px",
                  color: '#2C3E50', // ✅ Improved contrast
                  fontWeight: 400,
                  lineHeight: 1.5
                }}>
                  {item.MS_SangDescription}
                </p>

                <div className='row g-3'>
                  {/* Phone */}
                  <div className='col-lg-3 col-md-5 col-sm-12 d-flex align-items-center'>
                    <MdCall style={{ fontSize: 16, color: "#D35400" }} aria-hidden="true" />
                    <span style={{
                      fontFamily: "Poppins",
                      fontSize: 14,
                      fontWeight: 500,
                      color: "#2C3E50",
                      marginLeft: '8px'
                    }}>
                      +91 {item.MS_SangContactNumber}
                    </span>
                  </div>

                  {/* WhatsApp */}
                  <div className='col-lg-3 col-md-6 col-sm-12 d-flex align-items-center'>
                    <IoLogoWhatsapp style={{ fontSize: 18, color: "#27AE60" }} aria-hidden="true" />
                    <span style={{
                      fontFamily: "Poppins",
                      fontSize: 14,
                      fontWeight: 500,
                      color: "#2C3E50",
                      marginLeft: '8px'
                    }}>
                      +91 {item.MS_SangWhatsappNumber}
                    </span>
                  </div>

                  {/* Email */}
                  <div className='col-lg-4 col-md-6 col-sm-12 d-flex align-items-center'>
                    <TfiEmail style={{ fontSize: 16, color: "#D35400" }} aria-hidden="true" />
                    <span style={{
                      fontFamily: "Poppins",
                      fontSize: 14,
                      fontWeight: 500,
                      color: "#2C3E50",
                      marginLeft: '8px'
                    }}>
                      {item.MS_SangEmailID}
                    </span>
                  </div>
                </div>

                <hr style={{ borderColor: '#BDC3C7', margin: '15px 0' }} />

                {/* Team Members */}
                {item.MuniTeamInfo && item.MuniTeamInfo.length > 0 && (
                  <div>
                    {item.MuniTeamInfo.map((member, idx) => (
                      <div key={idx} style={{
                        fontFamily: 'Poppins',
                        fontSize: "14px",
                        color: '#2C3E50',
                        fontWeight: 500,
                        marginBottom: '4px'
                      }}>
                        {member.Name}, {member.Designation}, +91 {member.MobileNo}
                      </div>
                    ))}
                  </div>
                )}
              </div>
            </div>
          ))
        )}
      </div>

      {/* ✅ Scroll to Top Button (Accessible) */}
      <button
        className="scroll-to-top-button border-0 rounded-2"
        onClick={scrollToTop}
        aria-label="Scroll back to top"
        style={{
          position: "fixed",
          bottom: "20px",
          right: "20px",
          width: "40px",
          height: "40px",
          backgroundColor: "#E74C3C",
          color: "#fff",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          zIndex: 1000,
          boxShadow: "0 2px 10px rgba(0,0,0,0.2)",
          transition: "background-color 0.2s"
        }}
      >
        <IoArrowUpCircleOutline style={{ fontSize: "32px" }} />
      </button>
    </div>
  );
}